import React from 'react';
import { SideButton } from './SidebarButton';
import './Sidebar.scss';
import logo from '../../assets/images/logo/logo-reverse.png';
import history from '../../history';
export class SideBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            closed: false
        }
    }
 
    onClickLogoHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        history.replace(`/`);
    }

    render() { 
        return (
            <div className={"lognex-sidebar closed"} >
                <div className="lognex-brand" onClick={this.onClickLogoHandler}>                    
                    <SideButton closed={this.state.closed} clickHandler={this.onClickLogoHandler} />                     
                </div>
                <div className="content">
                    {this.props.content}
                </div>
            </div>
        )
    }
}
